import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Report } from 'src/app/interfaces/report';
import { HTTP_OPTIONS, URL_SERVICIOS } from 'src/app/shared';
const URL = `${URL_SERVICIOS}report`;

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) { }

  getReport = (data: Report) => this.http.post<any[]>(URL, JSON.stringify(data), HTTP_OPTIONS);
}
